import { render } from "./affiliate.html?vue&type=template&id=ba1e0830&scoped=true&ts=true"
import script from "./affiliate.ts?vue&type=script&lang=ts"
export * from "./affiliate.ts?vue&type=script&lang=ts"

import "./affiliate.scss?vue&type=style&index=0&id=ba1e0830&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba1e0830"]])

export default __exports__